function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { defaultBillingDayOfWeek, defaultBillingDayOfYear } from "../../constants";
import { Accounting, BillingTriggerType } from "../../types/api.model";
import { OneTimeInStagesModel, serviceTemplateBundleModel, serviceTemplateModel } from '..';
import { BillingDayOfMonthModel } from "../BillingDayOfMonth";
import { RecurrencePeriodTypes } from "../service-billing/model";
import * as serviceCostModel from "../service-cost";
import { ServiceIntegrationsModel } from "../ServiceIntegrations";
import { makeServiceTemplate, makeBillingOnApproval, makeBillingOneTimeManual, makeBillingOngoing, makeBillingRepeatableManual, generateId, makeBillingOneTimeInStages } from "./makers";
import { ServiceTemplateType } from "./model";
export function billingFromDTO(billedUpon) {
  switch (billedUpon.type) {
    case BillingTriggerType.OnApproval:
      return makeBillingOnApproval();
    case BillingTriggerType.OneTimeManual:
      return makeBillingOneTimeManual();
    case BillingTriggerType.Ongoing:
      return makeBillingOngoing(billedUpon.ongoing.recurrence.period.type);
    case BillingTriggerType.RepeatableManual:
      return makeBillingRepeatableManual(billedUpon.repeatableManual.recurrence.period.type);
    case BillingTriggerType.OneTimeInStages:
      return makeBillingOneTimeInStages(OneTimeInStagesModel.fromDTO(billedUpon.oneTimeInStages));
  }
}
export function billingToDTO(billing) {
  switch (billing.trigger) {
    case BillingTriggerType.OnApproval:
      return {
        type: BillingTriggerType.OnApproval
      };
    case BillingTriggerType.OneTimeManual:
      return {
        type: BillingTriggerType.OneTimeManual
      };
    case BillingTriggerType.Ongoing:
      return {
        type: BillingTriggerType.Ongoing,
        ongoing: {
          isPaused: false,
          prorateFirstInvoice: false,
          billUpfront: false,
          maxCharges: {
            enabled: false,
            limit: null,
            chargesLeft: null
          },
          recurrence: {
            period: {
              type: billing.recurrencePeriod,
              monthly: billing.recurrencePeriod === RecurrencePeriodTypes.Monthly ? {
                dayOfMonth: BillingDayOfMonthModel.make().toDBType()
              } : null,
              weekly: billing.recurrencePeriod === RecurrencePeriodTypes.Weekly ? {
                day: defaultBillingDayOfWeek
              } : null,
              biweekly: billing.recurrencePeriod === RecurrencePeriodTypes.BiWeekly ? {
                day: defaultBillingDayOfWeek
              } : null,
              yearly: billing.recurrencePeriod === RecurrencePeriodTypes.Yearly ? {
                dayOfYear: defaultBillingDayOfYear
              } : null
            }
          }
        }
      };
    case BillingTriggerType.RepeatableManual:
      return {
        type: BillingTriggerType.RepeatableManual,
        repeatableManual: {
          billUpfront: false,
          maxCharges: {
            enabled: false,
            limit: null,
            chargesLeft: null
          },
          recurrence: {
            period: {
              type: billing.recurrencePeriod,
              monthly: billing.recurrencePeriod === RecurrencePeriodTypes.Monthly ? {
                dayOfMonth: BillingDayOfMonthModel.make().toDBType()
              } : null,
              weekly: billing.recurrencePeriod === RecurrencePeriodTypes.Weekly ? {
                day: defaultBillingDayOfWeek
              } : null,
              biweekly: billing.recurrencePeriod === RecurrencePeriodTypes.BiWeekly ? {
                day: defaultBillingDayOfWeek
              } : null,
              yearly: billing.recurrencePeriod === RecurrencePeriodTypes.Yearly ? {
                dayOfYear: defaultBillingDayOfYear
              } : null
            }
          }
        }
      };
    case BillingTriggerType.OneTimeInStages:
      return {
        type: BillingTriggerType.OneTimeInStages,
        oneTimeInStages: billing.oneTimeInStages.toDTO()
      };
  }
}
export function fromService(service, oldServiceTemplate) {
  const {
    billing
  } = service;
  function makeBilling() {
    switch (billing.trigger) {
      case BillingTriggerType.OnApproval:
        return makeBillingOnApproval();
      case BillingTriggerType.OneTimeManual:
        return makeBillingOneTimeManual();
      case BillingTriggerType.Ongoing:
        return makeBillingOngoing(billing.recurrencePeriod);
      case BillingTriggerType.RepeatableManual:
        return makeBillingRepeatableManual(billing.recurrencePeriod);
      case BillingTriggerType.OneTimeInStages:
        return makeBillingOneTimeInStages(billing.oneTimeInStages);
    }
  }
  return makeServiceTemplate(_objectSpread(_objectSpread({}, oldServiceTemplate), {}, {
    id: service.serviceTemplateId,
    name: service.name,
    description: service.description,
    cost: service.cost,
    integrations: service.integrations,
    billing: makeBilling(),
    bundle: service.bundle ? serviceTemplateBundleModel.fromService(service) : undefined
  }));
}
export function fromDTO(dto) {
  return {
    id: dto.id,
    name: dto.name,
    description: dto.description,
    status: dto.status,
    cost: serviceCostModel.fromDBDTO(dto.cost),
    billing: billingFromDTO(dto.billedUpon),
    origin: dto.origin || null,
    integrations: ServiceIntegrationsModel.fromDTO(dto.integrations),
    usedIn: dto.usedIn || [],
    bundle: dto.bundle ? serviceTemplateBundleModel.fromDTO(dto.bundle) : undefined
  };
}
export function toDTO(service) {
  const dto = _objectSpread({
    id: service.id || generateId(),
    name: service.name,
    description: service.description,
    status: service.status,
    cost: serviceCostModel.toDBDTO(service.cost),
    billedUpon: billingToDTO(service.billing),
    usedIn: service.usedIn
  }, service.bundle ? {
    type: ServiceTemplateType.Bundle,
    bundle: serviceTemplateBundleModel.toDTO(service.bundle)
  } : {
    type: ServiceTemplateType.Service
  });
  const integratedId = serviceTemplateModel.integratedId({
    serviceTemplate: service,
    accounting: Accounting.QBO
  });
  if (integratedId) {
    dto.integratedId = integratedId;
  }
  if (service.origin) {
    dto.origin = service.origin;
  }
  if (service.integrations.hasIntegrations()) {
    dto.integrations = service.integrations.toJSON();
  }
  return dto;
}